import { render, staticRenderFns } from "./AppDownloadBanner.vue?vue&type=template&id=259df918&scoped=true"
import script from "./AppDownloadBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppDownloadBanner.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AppDownloadBanner.vue?vue&type=style&index=0&id=259df918&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259df918",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CBtn: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CBtn/CBtn.vue').default,CCard: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CCard/CCard.vue').default})
